import React from 'react';
import styled, { css } from 'styled-components';

import {
  IconButton,
  ButtonType,
  ButtonTone,
} from '@prisjakt/ui/button/variants';
import Badge from '../badge';
import { useAppContext } from 'src/components/app-context';
import { IconMegaphone } from '@prisjakt/ui/icon';

type Props = {
  onClickHandler: React.MouseEventHandler<
    HTMLAnchorElement | HTMLButtonElement
  >;
};

export const ChangelogToggle: React.FC<Props> = ({ onClickHandler }) => {
  const { t } = useAppContext();

  return (
    <Button
      onClick={onClickHandler}
      type={ButtonType.TEXT}
      tone={ButtonTone.LIGHT}
      ariaLabel={t('changelog', 'changelog.title')}
    >
      <Inner>
        <Badge noOutline />
        <IconMegaphone size={20} color="maybeBlue700" />
      </Inner>
    </Button>
  );
};

const Button = styled(IconButton)(
  p => css`
    position: relative;
    color: ${p.theme.icons.secondary};
  `
);

const Inner = styled.div`
  position: relative;
  display: flex;
`;
